import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const useQueryString = () => {
	const location = useLocation();
	const [queryString, setQueryString] = useState('');

	useEffect(() => {
		// Get the current query parameters from the URL
		const searchParams = new URLSearchParams(location.search);

		// Convert the search params to an object
		const params = {};
		searchParams.forEach((value, key) => {
			params[key] = value;
		});

		const tabType = location?.state?.type;

		// Get fabricName from location.state.selectedItem if it exists
		const fabricName = location?.state?.selectedItem?.fabricName || '';
		const colorName = location?.state?.selectedItem?.colorName || '';
		const graphicsName = location?.state?.selectedItem?.graphicsName || '';
		const themeName = location?.state?.selectedItem?.themeName || '';

		const filterName = {
			'key-fabric': 'fiberList',
			'key-color': 'colorList',
			'key-graphics': 'graphicsContentList',
			'key-prints': 'graphicsContentList',
			'key-theme': 'themeList'
		};

		// Split fabricName by "+" to create fiberList
		let list = '';
		if (fabricName && tabType === 'key-fabric') {
			list = '';
			list = fabricName.split('+').join(',');
		}
		if (colorName && tabType === 'key-color') {
			list = '';
			list = colorName.split('+').join(',');
		}
		if (graphicsName && tabType === 'key-graphics') {
			list = '';
			list = graphicsName.split('+').join(',');
		}
		if (graphicsName && tabType === 'key-prints') {
			list = '';
			list = graphicsName.split('+').join(',');
		}
		if (themeName && tabType === 'key-theme') {
			list = '';
			list = themeName.split('+').join(',');
		}

		// Construct the query string
		const constructedQueryString = Object.keys(params)
			.map((key) => `${key}=${params[key]}`)
			.join('&');

		// Append fiberList to the query string if it exists
		const finalQueryString = list
			? `?${constructedQueryString}&${filterName[tabType]}=${list}`
			: `?${constructedQueryString}`;

		// Store the constructed query string
		setQueryString(finalQueryString);
	}, [location.search]);

	return queryString;
};

export default useQueryString;
